import React from "react";
import './Popup.css';

function Popup ({
  isPopupOpen,
  closePopup, children}){
  // Children (mesto) - Instruction Component
  return(
    <div className={`popup ${isPopupOpen && "popup_open"}`}>
      <div className="popup__overlay" onClick={closePopup}></div>
      <div className="popup__card">
        <button type="button"  className="popup__close-button" onClick={closePopup}></button>
        {children}
      </div>
    </div>
  )
}

export default Popup;
